import { CbhFeatureFlag, useCbhFlag } from "@src/appV2/FeatureFlags";
import { useIsNavigationRedesignEnabled } from "@src/appV2/redesign/hooks/useIsNavigationRedesignEnabled";

export function useIsChatRedesignEnabled(): boolean {
  const isChatRedesignEnabled = useCbhFlag(CbhFeatureFlag.CHAT_REDESIGN_ENABLED, {
    defaultValue: false,
  });
  const isNavigationRedesignEnabled = useIsNavigationRedesignEnabled();

  return isChatRedesignEnabled && isNavigationRedesignEnabled;
}
